import { useReducer, useState} from 'react';
import { Button, Modal, Steps, notification } from 'antd';
import { ConfigAddonsSetting } from '@/components/instance/control/ConfigAddonsSetting';
import { SelectAddons } from '@/components/instance/control/SelectAddons';
import { ReviewAddons } from '@/components/instance/control/ReviewAddons';
import { useResourceParams } from '@refinedev/core';
import { installAddons } from '@/apis/addons';
import { TopBreadcrumb } from '@/layouts/TopBreadcrumb';
import { useResourceNavigate } from '@/hooks/useResourceNavigate';
import { useNavigate } from 'react-router-dom';

const { Step } = Steps;

export const AddAddons = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const initSelectedAddons = [];
  const navigate = useNavigate();
  const reducer = (state, action) => {
    switch(action.type) {
      case 'UPDATE':
        return state.map((item  ) => (item.id === action.payload.index ? action.payload.addon : item));
      case 'SET':
        return action.payload;
      default:
        return state;
    }
  }
  const [state, dispatch] = useReducer(reducer, initSelectedAddons);
  const { id } = useResourceParams();

  const getContentComponent = (currentStep) => {
    switch (currentStep) {
      case 0:
        return <SelectAddons props={{state, dispatch, id}}/>;
      case 1:
        return <ConfigAddonsSetting props={{state, dispatch}}/>;
      case 2:
        return <ReviewAddons props={{state, dispatch}}/>;
      default:
        return null;
    }
  };

  const handleStepChange = (newStep) => {
    setCurrentStep(newStep);
  };

  const handleNext = () => {
    if (currentStep < 2) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  }

  const handleAdd = () => {
    Modal.confirm({
      title: 'Install Add-ons',
      content: 'Are you sure to install ' + state.map(addon => addon.name).join(',') + ' ?' ,
      centered: true,
      onOk: () => {
        const selAddons = state.map(addon => ({
           id: addon.id, name: addon.name, type: addon.type, version: addon.version, config: (addon.config ? addon.config : "")
          }))
        installAddons(id, selAddons).then(({ status, value }) => {
          if (status === 'OK') {
            notification.success({
              description: 'Install add-ons success!'
            });
            navigate(-1);
          } else {
            notification.error({
              description: 'Install add-ons failed!'
            });
          }
        })
      },
      onCancel: () => {
        console.log("Cancel install add-ons");
      },
    });
  }

  return (
    <div>
      <TopBreadcrumb />
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <div style={{ width: '15%', padding: '20px', boxSizing: 'border-box' }}>

          <Steps current={currentStep} onChange={handleStepChange} direction="vertical" progressDot >
            <Step title="Step 1" description={<strong>Select Add-ons</strong>} />
            <Step title="Step 2" description={<strong>Configure selected add-on settings</strong>} />
            <Step title="Step 3" description={<strong>Review and add</strong>} />
          </Steps>
        </div>
        <div style={{ width: '85%', padding: '20px', boxSizing: 'border-box', overflowY: 'auto' }}>
          {getContentComponent(currentStep)}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
          <Button type="primary" onClick={handleCancel}>
            Cancel
          </Button>
          {currentStep > 0 && <Button type="primary" onClick={handlePrev}>
            Previous
          </Button>}
          {currentStep < 2 && <Button type="primary" onClick={handleNext}>
            Next
          </Button>}
          {currentStep == 2 &&
            <Button type="primary" onClick={handleAdd}>
              Add
            </Button>}
      </div>
    </div>);  
};  